import React from "react"

import {isBulkSelection} from "../../../../../gd/right-click-menu"
import FieldText_Popover from "../../../../generic/text/components/popover/popover"
import {FieldEditableProps} from "../../../../proto/render/editable"

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default class FieldTimeReportMessage_Editable extends React.Component<FieldEditableProps, State> {

    constructor(props: FieldEditableProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get isEditable():boolean {
        return !this.props.disabled
            && this.props.field.canEdit(this.props.model)
    }

    onMouseEnter = () => {
        if (!this.isEditable) {
            return
        }

        if (!this.state.isHovered) {
            this.setState({
                isHovered   : true
            })
        }
    }

    onMouseLeave = () => {
        if (this.state.showPopover) {
            return
        }

        if (this.state.isHovered) {
            this.setState({
                isHovered   : false
            })
        }
    }

    onValueSave = (value: string | null, hidePopover:boolean=true) => {

        if (this.props.onChange) {
            this.props.onChange(value)
        }

        hidePopover && this.hidePopover()
    }

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueSave(null, false)
        this.forceUpdate()
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (isBulkSelection(e)) {
            return
        }
        if (!this.isEditable) {
            return
        }

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {
        const classes = Classes("time-report-comment ui5-field-editable is-hovered w-100-percent h-100-percent p-l-5", this.props.className)
        const value = this.props.field.getViewValue(this.props.model)

        return (
            <div className      = {classes}
                 onMouseLeave   = {this.onMouseLeave}
                 onClick        = {this.onClick}>

                {!!value &&
                    <div className={Classes("txt-truncate", this.props.textClassName)}>{value}</div>
                }

                {!value &&
                    <div className="ui5-txt-no-accent-small txt-truncate">Add comment</div>
                }

                <div className="buttons p-r-8">
                    {!!value && !this.state.showPopover &&
                        <div className  = "btn-reset"
                             onClick    = {this.onDeleteClick}
                        />
                    }
                </div>

                {this.state.showPopover &&
                    <FieldText_Popover
                        field   = {this.props.field}
                        parent  = {this}
                        value   = {value}
                        onSave  = {this.onValueSave}
                    />}
            </div>
        )
    }

    renderNotHovered() {
        const classes = Classes("time-report-comment ui5-field-editable w-100-percent h-100-percent p-l-5", this.props.className)
        const value = this.props.field.getViewValue(this.props.model)

        return (
            <div className      = {classes}
                 onMouseEnter   = {this.onMouseEnter}
            >
                {!!value &&
                    <div className={Classes("txt-truncate", this.props.textClassName)}>{value}</div>
                }

                {!value &&
                    <div className="placeholder ui5-txt-no-accent-small txt-truncate">Add comment</div>
                }
            </div>
        )
    }

    render() {
        if (this.state.isHovered) {
            return this.renderHovered()
        } else {
            return this.renderNotHovered()
        }
    }
}
